<template>
  <div>
    <div
      class="limit-online-text"
      v-if="$store.state.plan.group != 'pro' && !currentUser.oneTimeEnd
        && $store.state.plan.group != 'white-label'
        && !isGuestUser"
    >
      <span v-if="$store.state.plan.group == 'free'">
        <span
          v-html="$i18nPresenter.t('asAFreeUserYouCanHostUpto', {
            x: planLimit
          })"
        ></span>
        <span class="cursor-pointer text-primary-90 ml-1" @click="goToUpgrade()">
          {{ $i18nPresenter.t('Upgrade from just {currency}{price}.' , {
            currency: symbolCurrency,
            price: fromJustNow
          })
          }}
        </span>
      </span>
      <span v-else-if="$store.state.plan.group == 'one-time'">
        <span></span>
        <span
          v-html="$i18nPresenter.t('youCanHostUptoOnYourEventday', {
            x: (planLimit)
          })"
        ></span>
        <i
          class="fas fa-question-circle"
          v-tooltip="oneTimeTooltip"
        />&nbsp;
        <span>
          {{ $i18nPresenter.t('Need more?') }}
          <a @click="goToUpgrade()" class="ml-1">{{ $i18nPresenter.t('Upgrade now') }}</a>.
        </span>
      </span>
      <span v-else>
        <span></span>
        <span
          v-html="$i18nPresenter.t('youCanHostUpto', {
            x: (planLimit)
          })"
        ></span>
        <span>
          <a @click="goToUpgrade()" class="ml-1">{{ $i18nPresenter.t('Upgrade now') }}</a>.
        </span>
      </span>
    </div>
    <div
      class="limit-online-text"
      v-if="$store.state.plan.group == 'one-time' && currentUser.oneTimeEnd"
    >
      {{ $i18nPresenter.t('Your event day has started.') }}
      {{ $i18nPresenter.t('You can host up to') }}
      <strong>{{ planLimit | formatNumber }}</strong> {{ $i18nPresenter.t('live participants until') }}
      <strong>{{ currentUser.oneTimeEnd | dateTimeFirst }}</strong>.
      <br>{{ $i18nPresenter.t('Need more?') }}
      <a @click="goToUpgrade()" class="ml-1">{{ $i18nPresenter.t('Upgrade now') }}</a>.
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
// services
import utils from '@/util'
import eventCategories from '@/constant/eventCategories'
import cookie from '@/services/cookie'
import PaymentLocalizationMixin from '@/components-v2/my-plan/user-pricing-v2/PaymentLocalizationMixin'

export default {
  components: {
  },
  mixins: [PaymentLocalizationMixin],
  data() {
    return {
      isGuestUser: !!cookie.getValue('aha-guest-user'),
    }
  },
  computed: {
    ...mapGetters(['planLimit']),
    ...mapState({
      presentation: (state) => state.presentation,
      currentUser: (state) => state.currentUser,
      slideActive: (state) => state.slideActive,
      sharePresentation: (state) => state.sharePresentation,
      isNewPresentation: (state) => state.isNewPresentation,
      plan: (state) => state.plan,
      planBenefit: (state) => state.planBenefit,
    }),
    oneTimeTooltip() {
      return this.$i18nPresenter.t('Your event day will start when you have more than 7 participants joining your presentation simultaneously and last for 24 hours')
    },
  },
  methods: {
    goToUpgrade() {
      if (this.plan.group !== 'free') {
        utils.mixpanelTracking(
          eventCategories.PRESENTATION_EDITOR,
          'Feature upgrade',
          'Middle participant limit',
        )
      } else {
        const limit = 50
        utils.mixpanelTracking(
          null,
          'click_textlink_upgrade_middle',
          null,
          null,
          {
            element_name: `Upgrade for higher participant limit (limit: ${limit})`,
            page: eventCategories.PRESENTATION_EDITOR,
            presentation_id: this.presentation.id,
          },
        )
      }
      this.$router.push('/apps/user-plan?redirect=/apps/user-plan')

      // add redirect to handle case: guest clicks upgrade -> go to sign-up first
    },

  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variable.scss";
.limit-online-text {
  font-size: 13px;
  text-align: center;
  padding-bottom: 12px;
  color: $suva-grey-color;
  max-width: 680px;
  margin: 0 auto;

  &.text-left {
    text-align: left;
    padding-bottom: 0;
    padding-top: 6px;
  }

  a {
    font-weight: bold;
    cursor: pointer;
    color: $primary-color;

    &:hover {
      color: $primary-hover-color;
      text-decoration: underline;
    }
  }

  @media (max-width: 1180px) {
    padding-left: 8px;
    padding-right: 8px;
  }
}
</style>
